import { useCallback, useEffect, useState } from 'react';
import {
	getUserProperty,
	setUserProperty,
} from '@jira/admin-pages__performance/src/setUserProperty.tsx';
import { useAccountId } from '@atlassian/jira-tenant-context-controller/src/components/account-id/index.tsx';

// Ensure this key matches the key in the old nav in navigation-apps/sidebar package
const PROPERTY_KEY = 'jira.user.settings.system.project-cleanup-onboarding-spotlight';

export const useProjectCleanupSpotlight = () => {
	const accountId = useAccountId();
	const [isProjectCleanupSpotlightActive, setIsProjectCleanupSpotlightActive] = useState(false);

	const getHasSeenProjectCleanupSpotlight = async (id: string) => {
		const response = await getUserProperty({
			accountId: id,
			propertyKey: PROPERTY_KEY,
			defaultValue: false,
		});
		// If they have not seen the spotlight, return true and mark as shown
		if (!response.value) {
			await setUserProperty({
				accountId: id,
				propertyKey: PROPERTY_KEY,
				propertyValue: true,
			});
			return false;
		}
		return true;
	};

	const fetchSpotlightState = useCallback(async () => {
		if (accountId !== null) {
			const response = await getHasSeenProjectCleanupSpotlight(accountId);
			setIsProjectCleanupSpotlightActive(!response);
		}
	}, [accountId]);

	useEffect(() => {
		fetchSpotlightState();
	}, [fetchSpotlightState]);

	return [isProjectCleanupSpotlightActive, setIsProjectCleanupSpotlightActive] as const;
};
